import DiagnosisStatusBadge from 'components/badge/DiagnosisStatusBadge';
import { DivConst } from 'constants/divConst';
import { AppHelper } from 'helpers/appHelper';
import { DiagnosisHelper } from 'helpers/diagnosisHelper';
import { DiagnosisResponseType } from 'types/api/diagnosisResponseType';

/**
 *　診断作成編集 診断状態表示コンポーネント
 */
export default function WsDiagnosisEditStatusInfo(props: {
  diagnosis: DiagnosisResponseType;
}): JSX.Element {
  /* ----------------------------------------------------------------------- */
  /* 型定義 */
  /* ----------------------------------------------------------------------- */

  /* ----------------------------------------------------------------------- */
  /* 変数定義 */
  /* ----------------------------------------------------------------------- */

  /* ----------------------------------------------------------------------- */
  /* ライフサイクル関数定義 */
  /* ----------------------------------------------------------------------- */

  /* ----------------------------------------------------------------------- */
  /* イベントハンドラ関数定義 */
  /* ----------------------------------------------------------------------- */

  /* ----------------------------------------------------------------------- */
  /* プライベート関数定義 */
  /* ----------------------------------------------------------------------- */
  /**
   * 公開情報の表示可否を返します。
   */
  const _isVisiblePublishInfo = (): boolean => {
    // 掲載(予約)ステータスの場合は表示
    if (props.diagnosis?.diagnosisStatusDiv === DivConst.items.diagnosisStatus.reserved.value) {
      return true;
    }
    // 一度でも掲載を迎えた診断の場合は表示
    if (props.diagnosis?.publishedAt != null) {
      return true;
    }
  };

  /* ----------------------------------------------------------------------- */
  /* JSX */
  /* ----------------------------------------------------------------------- */
  return (
    <>
      {props.diagnosis && (
        <div className="section-header user-detail">
          <div className="card-detail">
            {props.diagnosis.lineFlag ? (
              <>
                <ul className="list-unstyled list-inline">
                  <li className="list-inline-item">
                    <b>診断作成日</b>：
                    {AppHelper.formatTimeToDate(props.diagnosis.createdAt, 'yyyy/MM/dd')}
                  </li>
                  <li className="list-inline-item">
                    <DiagnosisStatusBadge
                      diagnosisStatusDiv={props.diagnosis?.diagnosisStatusDiv}
                    />
                  </li>
                  {_isVisiblePublishInfo() && (
                    <>
                      <li className="list-inline-item">
                        <b>公開期間</b>：
                        {DiagnosisHelper.formatPublishTerm({
                          diagnosisStatusDiv: props.diagnosis.diagnosisStatusDiv,
                          publishStartAt: props.diagnosis.publishStartAt,
                          publishEndAt: props.diagnosis.publishEndAt,
                          publishedAt: props.diagnosis.publishedAt,
                          terminatedAt: props.diagnosis.terminatedAt,
                        })}
                      </li>
                      <li className="list-inline-item">
                        <b>検索エンジン</b>：
                        <a>
                          {props.diagnosis.noIndexFlag && (
                            <span className="text-danger">インデックス対象外</span>
                          )}
                          {!props.diagnosis.noIndexFlag && <span>インデックス対象</span>}
                        </a>
                      </li>
                    </>
                  )}
                </ul>
                {_isVisiblePublishInfo() && (
                  <ul className="list-unstyled list-inline">
                    <li className="list-inline-item">
                      <b>公開URL</b>：
                      {props.diagnosis.diagnosisStatusDiv ===
                        DivConst.items.diagnosisStatus.published.value && (
                        <a
                          className="form-profile"
                          onClick={() =>
                            DiagnosisHelper.openLineProductionUrl(props.diagnosis.lineCd)
                          }
                        >
                          {DiagnosisHelper.getLineProductionUrl(props.diagnosis.lineCd)}
                        </a>
                      )}
                      {props.diagnosis.diagnosisStatusDiv !=
                        DivConst.items.diagnosisStatus.published.value && (
                        <span> {DiagnosisHelper.getLineProductionUrl(props.diagnosis.lineCd)}</span>
                      )}
                    </li>
                    <li className="list-inline-item">
                      <b>LINE友だち追加後のURL</b>：
                      {props.diagnosis.diagnosisStatusDiv ===
                        DivConst.items.diagnosisStatus.published.value && (
                        <a
                          className="form-profile"
                          onClick={() => DiagnosisHelper.openProductionUrl(props.diagnosis.cd)}
                        >
                          {DiagnosisHelper.getProductionUrl(props.diagnosis.cd)}
                        </a>
                      )}
                      {props.diagnosis.diagnosisStatusDiv !=
                        DivConst.items.diagnosisStatus.published.value && (
                        <span> {DiagnosisHelper.getProductionUrl(props.diagnosis.cd)}</span>
                      )}
                    </li>
                  </ul>
                )}
              </>
            ) : (
              <ul className="list-unstyled list-inline">
                <li className="list-inline-item">
                  <b>診断作成日</b>：
                  {AppHelper.formatTimeToDate(props.diagnosis.createdAt, 'yyyy/MM/dd')}
                </li>
                <li className="list-inline-item">
                  <DiagnosisStatusBadge diagnosisStatusDiv={props.diagnosis?.diagnosisStatusDiv} />
                </li>
                {_isVisiblePublishInfo() && (
                  <>
                    <li className="list-inline-item">
                      <b>公開期間</b>：
                      {DiagnosisHelper.formatPublishTerm({
                        diagnosisStatusDiv: props.diagnosis.diagnosisStatusDiv,
                        publishStartAt: props.diagnosis.publishStartAt,
                        publishEndAt: props.diagnosis.publishEndAt,
                        publishedAt: props.diagnosis.publishedAt,
                        terminatedAt: props.diagnosis.terminatedAt,
                      })}
                    </li>
                    <li className="list-inline-item">
                      <b>検索エンジン</b>：
                      <a>
                        {props.diagnosis.noIndexFlag && (
                          <span className="text-danger">インデックス対象外</span>
                        )}
                        {!props.diagnosis.noIndexFlag && <span>インデックス対象</span>}
                      </a>
                    </li>
                    <li className="list-inline-item">
                      <b>公開URL</b>：
                      {props.diagnosis.diagnosisStatusDiv ===
                        DivConst.items.diagnosisStatus.published.value && (
                        <a
                          className="form-profile"
                          onClick={() => DiagnosisHelper.openProductionUrl(props.diagnosis.cd)}
                        >
                          {DiagnosisHelper.getProductionUrl(props.diagnosis.cd)}
                        </a>
                      )}
                      {props.diagnosis.diagnosisStatusDiv !=
                        DivConst.items.diagnosisStatus.published.value && (
                        <span> {DiagnosisHelper.getProductionUrl(props.diagnosis.cd)}</span>
                      )}
                    </li>
                  </>
                )}
              </ul>
            )}
          </div>
        </div>
      )}
    </>
  );
}
